<template>
  <div class="relative overflow-hidden">
    <div class="relative">
      <slot></slot>
    </div>
    <template v-if="percent !== null && percent < 100">
      <div
        class="absolute left-0 bottom-0 w-full bg-[rgba(0,0,0,0.5)]"
        :style="maskStyle"
      ></div>
      <div class="progress-text absolute" :style="textStyle">
        {{ percentText }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ProgressContainer",
  props: {
    percent: {
      type: Number,
      required: false,
      default: null,
      validator: (v) => v === null || (v >= 0 && v <= 100),
    },
  },
  computed: {
    percentText() {
      return `${Math.round(this.percent || 0)}%`;
    },
    maskStyle() {
      // mask高度应为(100 - percent)%：初始为0，进度越高mask越高，100%时mask消失
      return {
        height: `${100 - this.percent}%`,
        transition: "height 0.3s",
        backgroundColor: "rgba(0,0,0,0.5)",
      };
    },
    textStyle() {
      return {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        color: "white",
      };
    },
  },
};
</script>
